import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import Icon from '../icon'
import LabeledProgressBar from '../LabeledProgressBar/LabeledProgressBar'
import { formatAmount } from '../../lib/numbers'
import styles from './PledgeAllocationCard.module.scss'

/** Total pledge with its Matching / Volunteer Pay Forward pool breakdown. */
export default function PledgeAllocationCard({
  total,
  matchAmount,
  volunteerAmount,
}) {
  const { t } = useTranslation()
  const civ = amount =>
    t('pledgeAllocation.civAmount', { amount: formatAmount(amount) })

  return (
    <section className={styles.card}>
      <div className={styles.header}>
        <Icon name="hand-holding-dollar" className={styles.headerIcon} />
        <h3 className={styles.title}>{t('pledgeAllocation.title')}</h3>
      </div>
      <div className={styles.body}>
        <div className={styles.totalRow}>
          <span className={styles.totalLabel}>
            {t('pledgeAllocation.total')}
          </span>
          <span className={styles.totalValue}>{civ(total)}</span>
        </div>
        <LabeledProgressBar
          label={t('pledgeAllocation.matchPool')}
          valueLabel={civ(matchAmount)}
          now={matchAmount}
          max={total}
          variant="purple"
        />
        <LabeledProgressBar
          label={t('pledgeAllocation.volunteerPool')}
          valueLabel={civ(volunteerAmount)}
          now={volunteerAmount}
          max={total}
          variant="pink"
        />
      </div>
    </section>
  )
}

PledgeAllocationCard.propTypes = {
  total: PropTypes.number.isRequired,
  matchAmount: PropTypes.number.isRequired,
  volunteerAmount: PropTypes.number.isRequired,
}
